export { default as Tag } from "./tag";
export type { TagProps } from "./tag";
